/**
 * TODO https://issues.amazon.com/issues/LOWA-9091
 * DO NOT CHANGE THIS FILE DIRECTLY.
 * THIS IS COPIED FROM `https://code.amazon.com/packages/PhotonPortalEmbedSdk/blobs/heads/workspaces-web/--/src/constants.ts`
 */
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

"use strict";

export module EmbedConstants {
  // Default Embed Options
  export const OPTION_STREAMING_URL = 'streamingURL';
  export const OPTION_HIDDEN_ELEMENTS = 'hiddenElements';
  export const OPTION_DISABLED_INPUT = 'disabledInput';

  // Max length of OPTION_HIDDEN_ELEMENTS
  export const MAX_HIDDEN_ELEMENTS_LENGTH = 14;

  // UI Elements
  export const ELEMENT_TOOLBAR = 'toolbar';
  export const ELEMENT_TOOLBAR_CATALOG = 'catalogButton';
  export const ELEMENT_TOOLBAR__WINDOW_SWITCHER = 'windowSwitcherButton';
  export const ELEMENT_TOOLBAR_FILES = 'filesButton';
  export const ELEMENT_TOOLBAR_CLIPBOARD = 'clipboardButton';
  export const ELEMENT_TOOLBAR_COPY_LOCAL = 'copyToLocalButton';
  export const ELEMENT_TOOLBAR_PASTE_REMOTE = 'pasteToRemoteButton';
  export const ELEMENT_TOOLBAR_SETTINGS = 'settingsButton';
  export const ELEMENT_TOOLBAR_MICROPHONE = 'enableMicrophoneButton';
  export const ELEMENT_TOOLBAR_STREAMING_MODE = 'streamingModeButton';
  export const ELEMENT_TOOLBAR_SCREEN_RESOLUTION = 'screenResolutionButton';
  export const ELEMENT_TOOLBAR_REGIONAL_SETTINGS = 'regionalSettingsButton';
  export const ELEMENT_TOOLBAR_FULLSCREEN = 'fullscreenButton';
  export const ELEMENT_TOOLBAR_END_SESSION = 'endSessionButton';
  export const ELEMENT_TOOLBAR_MAIN = 'mainToolbar';
  export const ELEMENT_ALERT = 'alert';

  //Input Events
  export enum InputListeners {
    KEY_DOWN,
    KEY_UP,
    KEY_PRESS,
    MOUSE_MOVE,
    MOUSE_DOWN,
    MOUSE_UP,
    MOUSE_LEAVE,
    WHEEL,
    TOUCH_START,
    TOUCH_MOVE,
    TOUCH_END,
    TOUCH_CANCEL
  }

  // Available Embed Events
  export class Events {
    static EVENT_API_BRIDGE = 'appstreamAPI';
    static EVENT_SESSION_STATE_CHANGED = 'sessionStateChange';
    static EVENT_USER_INTERFACE_STATE_CHANGED = 'userInterfaceStateChange';
    static EVENT_SESSION_ENDED = 'embedSessionEnded';
    static EVENT_SESSION_RESIZE = 'sessionResize';
    static EVENT_SESSION_ERROR = 'sessionError';
    static EVENT_PARAM_SESSION_STATUS = 'sessionStatus';
    static EVENT_PARAM_STATUS = 'status';
    static EVENT_PARAM_ERROR = 'error';
    static EVENT_SPINNER = 'spinner';
    static EVENT_FILE_UPLOAD_PROGRESS = 'fileUploadProgress';
    static EVENT_COPY_FROM_REMOTE = 'copyFromRemote';
    static EVENT_SESSION_METRICS = 'sessionMetrics';
  }

  // Available Screen Resolutions
  export enum Resolutions {
    MATCH_LOCAL_DISPLAY = 'matchLocalDisplay',
    KEEP_REMOTE_SERVER_DISPLAY = 'keepRemoteServerDisplay',
    SIZE_2560_X_1440 = 'size2560X1440',
    SIZE_1920_X_1080 = 'size1920X1080',
    SIZE_1280_X_720 = 'size1280X720',
    SIZE_1024_X_768 = 'size1024X768',
    SIZE_800_X_600 = 'size800X600'
  }

  // Available Embed Method calls
  export const METHOD_END_SESSION = 'endSession';
  export const METHOD_SEND_KEYS = 'sendKeys';
  export const METHOD_SEND_KEYBOARD_EVENT = 'sendKeyboardEvent';
  export const METHOD_ENTER_FULLSCREEN = 'enterFullscreen';
  export const METHOD_EXIT_FULLSCREEN = 'exitFullscreen';
  export const METHOD_SHOW_SOFTKEYBOARD = 'showSoftkeyboard';
  export const METHOD_HIDE_SOFTKEYBOARD = 'hideSoftkeyboard';
  export const METHOD_LAUNCH_APP = 'launchApp';
  export const METHOD_LAUNCH_APP_SWITCHER = 'launchAppSwitcher';
  export const METHOD_UPDATE_SPINNER_STATE = 'updateSpinnerState';
  export const METHOD_REFRESH_SESSION = 'refreshSession';

  // PerformAction methods
  export const METHOD_SET_MICROPHONE = 'setMicrophone';
  export const METHOD_SET_WEBCAM = 'setWebcam';
  export const METHOD_SET_STREAMING_MODE = 'setStreamingMode';
  export const METHOD_SWITCH_WINDOWS = 'switchWindows';
  export const METHOD_TOGGLE_MULTI_MONITOR = 'toggleMultiMonitor';
  export const METHOD_LIST_FILES = 'listFiles';
  export const METHOD_CREATE_FOLDER = 'createFolder';
  export const METHOD_RENAME_FILE = 'renameFile';
  export const METHOD_DELETE_FILE = 'deleteFile';
  export const METHOD_DOWNLOAD_FILE = 'downloadFile';
  export const METHOD_UPLOAD_FILE = 'uploadFile';
  export const METHOD_SET_SCREEN_RESOLUTION = 'setScreenResolution';
  export const METHOD_PASTE_TO_REMOTE = 'pasteToRemote';
  export const METHOD_LIST_CATALOG = 'listCatalog';
  export const METHOD_SET_KEYBOARD_SETTINGS = 'setKeyboardSettings';

  // Bridge communication
  export const BRIDGE_CLIENT_NAMESPACE = 'appstream.embed.message.client'; //namespace for messages sent FROM portal TO the client (embedded container)
  export const BRIDGE_HOST_NAMESPACE = 'appstream.embed.message.host'; //namespace for messages sent FROM the client (embedded container) TO portal

  //internal methods
  export const METHOD_EMBED_CLIENT_INTERFACE_READY = 'appstreamEmbedClientInterfaceReady';
  export const METHOD_EMBED_OPTIONS = 'appstreamEmbedOptions';
  export const METHOD_UPDATE_USER_INTERFACE_STATE = 'updateUserInterfaceState';
  export const METHOD_UPDATE_SESSION_STATE = 'updateSessionState';
  export const METHOD_SEND_INITIAL_STATE = "sendInitialState"; // As part of the handshake between the embed client and embed service, we want to send the initial state objects.
  export const METHOD_DISCONNECT_SESSION = 'disconnectSession';
  export const METHOD_REPORT_ERROR = 'reportError';
  export const METHOD_FILE_UPLOAD_PROGRESS = 'fileUploadProgress';
  export const METHOD_COPY_FROM_REMOTE = 'copyFromRemote';
  export const METHOD_SESSION_METRICS = 'sessionMetrics';

  // Timeout time for setting up the API Bridge
  export const HOST_WAIT_TIMEOUT = 10000; // milliseconds: 10s
  // Timeout in milliseconds for customer to send embed options to AppStream
  export const CLIENT_WAIT_TIMEOUT = 1000;
  // Timeout in milliseconds for AppStream to confirm disconnect before we destroy the iFrame.
  export const DISCONNECT_WAIT_TIMEOUT = 1000;

  export enum SessionStatus {
    Unknown, //effectively not started & not reserved
    Reserved,
    Started,
    Disconnected,
    Ended
  }

  /**
   * This enum exists to communicate reasons for why a session would have ended.
   * There is another enum in photon/app/scripts/commons, Enums.ErrorCode which has an existing list of termination
   * error codes. In the below enum, we should only include enums that are not captured in Enums.ErrorCode.
   */
  export enum SessionTerminationReason {
    USER_ENDED_SESSION
  }

  export enum ResponseStatus {
    SUCCESS = "success",
    ERROR = "error"
  }

  export module ErrorMessages {
    export const VALIDATION_ERROR = "The input fails to satisfy the constraints specified by an AWS service.";
    export const MISSING_PARAMETER = "A required parameter for the specified action is not supplied.";
    export const INTERNAL_SERVER_ERROR = "The request processing has failed because of an unknown error, exception or failure.";
    export const INVALID_ACTION = "The given action to perform is invalid."
    export const BRIDGE_NOT_READY = "The AppStream embed is still initializing and not ready to perform this action.";
  }

  export enum EmbedKeyboardLocation {
    DOM_KEY_LOCATION_STANDARD = KeyboardEvent.DOM_KEY_LOCATION_STANDARD,
    DOM_KEY_LOCATION_LEFT = KeyboardEvent.DOM_KEY_LOCATION_LEFT,
    DOM_KEY_LOCATION_RIGHT = KeyboardEvent.DOM_KEY_LOCATION_RIGHT,
    DOM_KEY_LOCATION_NUMPAD = KeyboardEvent.DOM_KEY_LOCATION_NUMPAD
  }

  export module MessageVersions {
    export const V1 = "1";
    export const V2 = "2";
  }

  export module ClientVersions {
    export const V1 = "1.0.0";
  }

  export enum StreamingMode {
    BEST_RESPONSIVENESS = "bestResponsiveness",
    BEST_QUALITY = "bestQuality"
  }
}
